import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Landing pages for Stripe Connect hosted onboarding.
// mode="return": the server finished (or exited) — re-check status, then go to onboarding.
// mode="refresh": the account link expired — mint a fresh link and bounce back to Stripe.
export default function ConnectReturn({ mode = "return" }) {
  const nav = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      if (mode === "refresh") {
        try {
          const { data } = await api.post("/server/connect/onboard", {});
          if (data.url) { window.location.assign(data.url); return; }
        } catch { /* fall through */ }
        nav("/server/onboarding");
        return;
      }
      try {
        const { data } = await api.get("/server/connect/status");
        if (data.payouts_enabled) toast.success("Payout setup complete — you're all set!");
        else toast.info("Payout setup is still in review. You can check back shortly.");
      } catch { /* noop */ }
      nav("/server/onboarding");
    })();
  }, [mode, nav]);

  return (
    <div className="mx-auto max-w-md py-24 text-center" data-testid="connect-return">
      <p className="text-slate-500">Finishing payout setup…</p>
    </div>
  );
}
